<app-pixel-creature class="avatar" [addr]="address()"></app-pixel-creature>

<div class="head">
  <span class="pname" [style.color]="address() | addressColor">
    <app-identity [username]="player().username" [twitterHandle]="player().twitterHandle ?? null"></app-identity>
  </span>
</div>

<div class="record">
  <span class="record-w">W {{ player().wins ?? 0 }}</span>
  <span class="record-sep">·</span>
  <span class="record-l">L {{ player().losses ?? 0 }}</span>
</div>

@if (!isSelf()) {
  <div class="reveal" (click)="$event.stopPropagation()">
    <app-format-segment
      class="row-fmt"
      [compact]="true"
      [value]="mode()"
      [disabled]="challengePending()"
      (valueChange)="mode.set($event)"
    ></app-format-segment>
    <button
      class="action"
      [class.pending]="challengePending()"
      [disabled]="challengeDisabled()"
      (click)="onSendClick($event)"
    >
      @if (challengePending()) {
        <span class="spinner"></span>
        Cancel
      } @else {
        Send Challenge
      }
    </button>
  </div>
}
